import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    const processSession = async () => {
      if (hasProcessed.current) return;
      hasProcessed.current = true;

      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        navigate('/login');
        return;
      }

      try {
        const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
        const { data } = await axios.post(
          `${API}/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        setUser(data);
        
        if (data.role === 'buyer') {
          navigate('/buyer-dashboard', { replace: true, state: { user: data } });
        } else if (data.role === 'supplier') {
          navigate('/supplier-dashboard', { replace: true, state: { user: data } });
        } else if (data.role === 'admin') {
          navigate('/admin-dashboard', { replace: true, state: { user: data } });
        } else {
          navigate('/', { replace: true });
        }
      } catch (error) {
        console.error('Session processing error:', error);
        navigate('/login');
      }
    };

    processSession();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
        <p className="mt-4 text-muted-foreground">Completing sign-in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
